export const deltaChanged = delta => {
    return (
        !!delta.top || !!delta.left || delta.width !== 1 || delta.height !== 1
    );
};

// If user prefers reduced motion, turn off animations by setting duration to 0
// const motionMultiplier =
//     parseInt(
//         getComputedStyle(document.documentElement).getPropertyValue(
//             '--motionOn',
//         ),
//         10,
//     ) === 1
//         ? 1
//         : 0;

export const timing = duration => duration * process.env.MIX_DELAY_FACTOR;
